"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaNotTouch = exports.mediaTouch = exports.maxWidth = void 0;
exports.isDevice = isDevice;
exports.media = media;
exports.mediaMin = mediaMin;
exports.mediaMax = mediaMax;
exports.mediaMinMax = mediaMinMax;
const web_api_1 = require("../utils/web-api");
const tma_api_1 = require("../utils/tma-api");
const url_1 = require("./url");
const log_1 = require("./log");
exports.maxWidth = {
    mobile: 440,
    tablet: 1020
};
function isDevice(device) {
    var _a;
    const window = (0, url_1.getWindow)();
    if (!window) {
        return device === 'desktop';
    }
    // TODO: remove this check when weba will fix viewport width
    if ((0, tma_api_1.isTmaPlatform)('weba')) {
        return true;
    }
    const width = window.innerWidth;
    switch (device) {
        case 'desktop':
            return width > exports.maxWidth.tablet;
        case 'tablet':
            return width > exports.maxWidth.mobile;
        default:
        case 'mobile':
            let isMobile = width <= exports.maxWidth.mobile || (0, web_api_1.isOS)('ios', 'android', 'ipad');
            if (isMobile) {
                const isTelegram = !!((_a = (0, url_1.getWindow)()) === null || _a === void 0 ? void 0 : _a.TelegramWebviewProxy);
                const maxTouchPoints = navigator.maxTouchPoints || 0;
                if (isTelegram && maxTouchPoints === 0) {
                    isMobile = false;
                }
                (0, log_1.logDebug)("isDevice mobile isTelegram and maxTouchPoints:", isMobile, isTelegram, maxTouchPoints);
            }
            return isMobile;
    }
}
function media(device) {
    switch (device) {
        case 'mobile':
            return `@media (max-width: ${exports.maxWidth.mobile}px)`;
        case 'tablet':
            return `@media (max-width: ${exports.maxWidth.tablet}px) (min-width: ${exports.maxWidth.mobile}px)`;
        default:
        case 'desktop':
            return `@media (min-width: ${exports.maxWidth.tablet}px)`;
    }
}
function mediaMin(px) {
    return `@media (min-width: ${px}px)`;
}
function mediaMax(px) {
    return `@media (max-width: ${px}px)`;
}
function mediaMinMax(pxMin, pxMax) {
    return `@media (min-width: ${pxMin}px) and (max-width: ${pxMax}px)`;
}
exports.mediaTouch = '@media (hover: none)';
exports.mediaNotTouch = '@media not all and (hover: none)';
